import type { NotificationDecisionTransformResult } from "@/lib/file-extraction/types";
import type { DecizieInregistrareInput } from "@/types/decizieInregistrare";

export function mapDecisionToInput(
  sessionId: string,
  decision: NotificationDecisionTransformResult
): DecizieInregistrareInput {
  return {
    session_id: sessionId,
    decision_number: decision.decisionNumber,
    decision_date: decision.decisionDate,
    entity_name: decision.entityName,
    address: decision.address,
    county: decision.county,
    cui: decision.cui,
    category: decision.category,
    category_code: decision.categoryCode,
    registration_number: decision.registrationNumber,
    sectors: decision.sectors,
  };
}

const MSG_REQ = "Acest câmp este obligatoriu";

export function validateDecizieFields(input: DecizieInregistrareInput): {
  isValid: boolean;
  fieldErrors: Record<string, string>;
} {
  const errors: Record<string, string> = {};

  if (!input.decision_number?.trim()) {
    errors["decision_number"] = "Numărul deciziei este obligatoriu";
  }
  if (!input.registration_number?.trim()) {
    errors["registration_number"] = "Numărul de înregistrare este obligatoriu";
  }
  if (!input.category?.trim()) {
    errors["category"] = "Categoria este obligatorie";
  }
  if (!input.decision_date?.trim()) {
    errors["decision_date"] = "Data deciziei este obligatorie";
  }
  if (!input.county?.trim()) {
    errors["county"] = MSG_REQ;
  }
  if (!input.address?.trim()) {
    errors["address"] = MSG_REQ;
  }
  if (!input.sectors || input.sectors.length === 0) {
    errors["sectors"] = "Cel puțin un sector este obligatoriu";
  }

  return { isValid: Object.keys(errors).length === 0, fieldErrors: errors };
}
